import { useEffect } from "react";
import { useLocation } from "react-router";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
const useVerificationPageHook = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === allowedLinks.blockedVerification) {
      const content = document.getElementById("content");
      if (content.classList.contains("text_page-1")) {
        content.classList.remove("text_page-1");
        content.classList.add("text_page-");
      }
    }
  }, [pathname]);
};
export {
  useVerificationPageHook
};
